import { Tooltip } from 'antd';
import { Box } from '@mui/material';

const DefaultScreenIcon = ({ color }) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
		<path d="M3.33398 8H12.6673" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

const FullScreenIcon = ({ color }) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
		<path d="M10 2H14V6" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M6 14H2V10" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M14.0007 2L9.33398 6.66667" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M2 13.9987L6.66667 9.33203" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

const ScreenMenu = ({ screenSize, setScreenSize, iconColor = '#fff', activeBorderColor = '#fff' }) => {
	return (
		<Box sx={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
			<Tooltip title="Default Screen">
				<Box
					onClick={() => setScreenSize('md')}
					sx={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						transition: 'all 0.3s',

						'&:hover': {
							transform: 'scale(1.25)',
						},
					}}
				>
					<DefaultScreenIcon color={screenSize === 'md' ? '#155DFC' : iconColor} />
				</Box>
			</Tooltip>

			<Tooltip title="Full Screen">
				<Box
					onClick={() => setScreenSize('full')}
					sx={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						transition: 'all 0.3s',

						'&:hover': {
							transform: 'scale(1.2)',
						},
					}}
				>
					<FullScreenIcon color={screenSize === 'full' ? '#155DFC' : iconColor} />
				</Box>
			</Tooltip>
		</Box>
	);
};

export default ScreenMenu;
